import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M23.3 5.08a6.57 6.57 0 0 0-10.44-1.71l-.86.78-.83-.76a6.52 6.52 0 0 0-5.68-1.8A6.45 6.45 0 0 0 .7 5.08a6.38 6.38 0 0 0 1.21 7.46l9.37 9.66a1 1 0 0 0 1.44 0l9.36-9.64a6.4 6.4 0 0 0 1.22-7.48Zm-2.64 6.07-8.3 8.55a.53.53 0 0 1-.36.15.55.55 0 0 1-.36-.15l-8.31-8.56A4.43 4.43 0 0 1 2.48 6a4.5 4.5 0 0 1 3.33-2.44 4.57 4.57 0 0 1 4 1.29l1.53 1.39a1 1 0 0 0 1.34 0l1.56-1.42a4.56 4.56 0 0 1 4-1.26A4.5 4.5 0 0 1 21.52 6a4.44 4.44 0 0 1-.86 5.15Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }